import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'icon-plus',
  templateUrl: './plus.component.html',
  styleUrls: ['./plus.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlusComponent {}
